<a *ngIf="isAuthorized$ | async"
   [routerLink]="[pageRoute, 'edit', 'metadata']"
   class="edit-button btn btn-dark btn-sm"
   [ngbTooltip]="tooltipMsg | translate"
   role="button" [title]="tooltipMsg |translate" [attr.aria-label]="tooltipMsg |translate">
  <i class="fas fa-pencil-alt fa-fw"></i>
</a>
